module.exports = __webpack_public_path__ + "img/planning-light.04501eb6.svg";